"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonWidgetMenuState = exports.ButtonWidgetAlignment = exports.ButtonWidgetSize = exports.ButtonWidgetCurve = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var classnames_1 = __importDefault(require("classnames"));
var mobx_1 = require("mobx");
var react_transition_group_1 = require("react-transition-group");
var WidgetManager_1 = require("../../WidgetManager");
var ButtonWidgetMenu_1 = __importDefault(require("./ButtonWidgetMenu/ButtonWidgetMenu"));
var BehaviourBuilder_1 = require("Project/QwilrEditor/Behaviours/BehaviourBuilder");
var Button_1 = require("ContentTokens/Models/Button");
Object.defineProperty(exports, "ButtonWidgetAlignment", { enumerable: true, get: function () { return Button_1.ButtonWidgetAlignment; } });
var Types_1 = require("Tokens/Types");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var ButtonWidgetCurve;
(function (ButtonWidgetCurve) {
    ButtonWidgetCurve["None"] = "none";
    ButtonWidgetCurve["Slight"] = "slight";
    ButtonWidgetCurve["Some"] = "some";
    ButtonWidgetCurve["Lots"] = "lots";
})(ButtonWidgetCurve = exports.ButtonWidgetCurve || (exports.ButtonWidgetCurve = {}));
var ButtonWidgetSize;
(function (ButtonWidgetSize) {
    ButtonWidgetSize["Small"] = "small";
    ButtonWidgetSize["Medium"] = "medium";
    ButtonWidgetSize["Large"] = "large";
})(ButtonWidgetSize = exports.ButtonWidgetSize || (exports.ButtonWidgetSize = {}));
var ButtonWidgetMenuState;
(function (ButtonWidgetMenuState) {
    ButtonWidgetMenuState["Toolbar"] = "toolbar";
    ButtonWidgetMenuState["LinkEdit"] = "edit";
    ButtonWidgetMenuState["None"] = "none";
})(ButtonWidgetMenuState = exports.ButtonWidgetMenuState || (exports.ButtonWidgetMenuState = {}));
var maxTextLength = 50;
var ButtonWidget = (function (_super) {
    __extends(ButtonWidget, _super);
    function ButtonWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.storedMenuState = ButtonWidgetMenuState.None;
        _this.isTextInputFocussed = false;
        _this.textInputElement = null;
        _this.textBeforeModification = undefined;
        _this.renderButton = function () {
            var text = _this.props.text;
            var placeholder = "Name your button";
            return (react_1.default.createElement("div", { className: "button-widget__button user-font", onClick: _this.selectButton, "data-slate-editor": true },
                react_1.default.createElement("div", { className: "button-widget__button-expander" }, !!text ? text : placeholder),
                react_1.default.createElement(kaleidoscope_1.TextInput, { label: "Button text", labelHidden: true, className: "button-widget__button-text", value: text, placeholder: placeholder, onChange: _this.updateText, onClick: function (e) { return e.stopPropagation(); }, onKeyDown: _this.handleKeyPress, variant: kaleidoscope_1.TextInputVariant.Borderless, elementSize: 1, autoComplete: "none", maxLength: maxTextLength, onFocus: function () { return _this.updateIsTextInputFocussed(true); }, onBlur: function () { return _this.updateIsTextInputFocussed(false); }, ref: function (x) {
                        _this.textInputElement = x;
                    } })));
        };
        _this.renderNoLinkWarning = function () {
            return (react_1.default.createElement("div", { className: "button-widget__warnings-no-link", onClick: function () { return _this.handleChangeMenuState(ButtonWidgetMenuState.LinkEdit); } },
                react_1.default.createElement(icons_1.Unlink, { size: icons_1.IconSize.Small }),
                react_1.default.createElement("span", { className: "button-widget__warnings-no-link-text", contentEditable: false }, "NO LINK ADDED")));
        };
        _this.renderLengthWarning = function () {
            var remaining = maxTextLength - _this.props.text.length;
            return (react_1.default.createElement("div", { className: "button-widget__warnings-max-length" }, "".concat(remaining, " characters left (max ").concat(maxTextLength, ")")));
        };
        _this.renderWarnings = function () {
            var showLengthWarning = _this.showTextLengthWarning && _this.isTextInputFocussed;
            var showNoLinkWarning = !_this.props.href;
            return (react_1.default.createElement("div", { className: "button-widget__warnings" },
                react_1.default.createElement(react_transition_group_1.CSSTransition, { in: showNoLinkWarning, timeout: kaleidoscope_2.AnimationDuration.Short, classNames: "button-widget__warnings--transition", mountOnEnter: true, unmountOnExit: true }, _this.renderNoLinkWarning()),
                react_1.default.createElement(react_transition_group_1.CSSTransition, { in: showLengthWarning, mountOnEnter: true, unmountOnExit: true, timeout: kaleidoscope_2.AnimationDuration.Short, classNames: "button-widget__warnings--transition" }, _this.renderLengthWarning())));
        };
        _this.handleChangeMenuState = function (next) {
            _this.storedMenuState = next;
        };
        _this.updateIsTextInputFocussed = function (focussed) {
            if (focussed) {
                _this.textBeforeModification = _this.props.text;
            }
            if (!focussed) {
                _this.handleChangeMenuState(ButtonWidgetMenuState.None);
                if (_this.textBeforeModification !== _this.props.text) {
                    _this.props.telemetry.buttonTextEdited(_this.props.text);
                }
                _this.textBeforeModification = undefined;
            }
            _this.isTextInputFocussed = focussed;
        };
        _this.updateButton = function (propertiesToUpdate) {
            var eventData = {
                action: "update",
                path: _this.props.widgetManager.getPath(_this.props.element),
                toUpdate: propertiesToUpdate,
            };
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("button", eventData));
        };
        _this.deleteButton = function (event) {
            event.preventDefault();
            var updateData = {
                action: "delete",
                path: _this.props.widgetManager.getPath(_this.props.element),
            };
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("button", updateData));
        };
        _this.selectButton = function (event) {
            event.preventDefault();
            _this.handleChangeMenuState(ButtonWidgetMenuState.Toolbar);
            var selectData = {
                action: "select",
                path: _this.props.widgetManager.getPath(_this.props.element).concat([0]),
            };
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("button", selectData));
        };
        _this.updateAlignment = function (alignment) {
            _this.updateButton({ alignment: alignment });
        };
        _this.updateText = function (text) {
            _this.updateButton({ text: text });
        };
        _this.reselectText = function (event) {
            if (document.activeElement.type == "text") {
                return;
            }
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("button", {
                eventType: "reselection",
            }));
        };
        _this.handleKeyPress = function (event) {
            switch (event.key) {
                case BehaviourBuilder_1.KeyType.Enter: {
                    event.preventDefault();
                    if (event.shiftKey) {
                        break;
                    }
                    _this.triggerEventWithPath("addParagraphBelow");
                    break;
                }
                case BehaviourBuilder_1.KeyType.ArrowUp: {
                    event.preventDefault();
                    if (_this.textInputElement) {
                        _this.textInputElement.blur();
                        _this.triggerEventWithPath("arrowUpInLabel");
                    }
                    break;
                }
                case BehaviourBuilder_1.KeyType.ArrowDown: {
                    event.preventDefault();
                    if (_this.textInputElement) {
                        _this.textInputElement.blur();
                        _this.triggerEventWithPath("arrowDownInLabel");
                    }
                    break;
                }
            }
        };
        _this.triggerEventWithPath = function (action) {
            var data = {
                action: action,
                path: _this.props.widgetManager.getPath(_this.props.element),
            };
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("button", data));
        };
        return _this;
    }
    ButtonWidget.prototype.componentDidUpdate = function (prevProps) {
        if (!prevProps.autoFocus && this.props.autoFocus) {
            this.focusOnTextInput();
        }
    };
    ButtonWidget.prototype.componentDidMount = function () {
        if (this.props.autoFocus) {
            this.focusOnTextInput();
        }
    };
    ButtonWidget.prototype.render = function () {
        var _a = this.props, attributes = _a.attributes, children = _a.children, alignment = _a.alignment, telemetry = _a.telemetry;
        var isSelected = this.props.isSelected || this.props.toolbarBeingUsed;
        return (react_1.default.createElement("div", __assign({ className: "button-widget__container project-block__block-element" }, attributes),
            react_1.default.createElement("div", { className: (0, classnames_1.default)("button-widget", {
                    "button-widget--left-aligned": alignment === "left",
                    "button-widget--selected": isSelected && !this.isTextInputFocussed,
                    "button-widget--with-warnings": this.showTextLengthWarning,
                }), contentEditable: false },
                react_1.default.createElement(ButtonWidgetMenu_1.default, { href: this.props.href, alignment: this.props.alignment, update: this.updateButton, deleteWidget: this.deleteButton, showMenu: this.showMenu, updateAlignment: this.updateAlignment, reselectText: this.reselectText, blockStore: this.props.blockStore, brandStore: this.props.brandStore, menuState: this.storedMenuState, onChangeMenuState: this.handleChangeMenuState, telemetry: telemetry, tokensEnabled: this.props.tokensEnabled !== Types_1.TokensEnableState.Disabled }),
                this.renderButton(),
                this.renderWarnings()),
            children));
    };
    Object.defineProperty(ButtonWidget.prototype, "showMenu", {
        get: function () {
            var isButtonInUse = this.props.isSelected || this.props.toolbarBeingUsed;
            if (this.storedMenuState === ButtonWidgetMenuState.None) {
                return false;
            }
            if (isButtonInUse && !this.isTextInputFocussed) {
                return true;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    ButtonWidget.prototype.focusOnTextInput = function () {
        if (this.textInputElement) {
            this.textInputElement.focus();
            this.updateButton({ autoFocus: false });
        }
    };
    Object.defineProperty(ButtonWidget.prototype, "showTextLengthWarning", {
        get: function () {
            if (this.props.text.length >= maxTextLength - 10) {
                return true;
            }
            else {
                return false;
            }
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], ButtonWidget.prototype, "storedMenuState", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ButtonWidget.prototype, "isTextInputFocussed", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ButtonWidget.prototype, "showMenu", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ButtonWidget.prototype, "handleChangeMenuState", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ButtonWidget.prototype, "updateIsTextInputFocussed", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ButtonWidget.prototype, "showTextLengthWarning", null);
    ButtonWidget = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ButtonWidget);
    return ButtonWidget;
}(react_1.default.Component));
exports.default = ButtonWidget;
